// extracted by css-extract-rspack-plugin
module.exports =  {"loading":"LoadingPage__loading--UAEeX"};